import { Component } from '@angular/core';

@Component({
  selector: 'app-nav-prepusueto',
  imports: [],
  templateUrl: './nav-presupuesto.html',
  styleUrl: './nav-presupuesto.css'
})
export class NavPresupuesto {

}